// extracted by mini-css-extract-plugin
export default {"content-container":"roleManagement_content-container__Br1Rh","main-text":"roleManagement_main-text__PacJx"};